/* eslint-disable @typescript-eslint/no-unused-vars */
import { NotAny } from '../type';

/**
 * Checks that `value` is not `any` or `unknown`.
 *
 * Note that it won't work if you explicitly provide the type parameter, it needs to be inferred from the `value`.
 */
export const assertNotAny = <T>(value: NotAny<T>): void => {
    throw new Error('This code is supposed to be used only in typetests');
};
